import { Component, Input, OnDestroy } from '@angular/core';

import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { v4 as uuidv4 } from 'uuid';

import { FormsModule } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import {  ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { Module, RequestModule } from '../../../models';
import { AdminService } from '../../../services';
import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { ModuleForm } from '../modules-editor/module.form';
import { ModulesEditorComponent } from '../modules-editor/modules-editor.component';
import { ModuleFilter } from './module.filter';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss'],
  standalone: true,
  imports: [GridModule, TextBoxModule,  ExcelModule,  DropDownListModule, FormsModule]
})

export class ModulesComponent extends BaseGridComponent<Module> implements OnDestroy {

  @Input() public licenseId: string | null = null;
  @Input() public hasApi: boolean | null = null;
  @Input() public active: boolean | null = null;
  @Input() public includeHost: boolean | null = false;

  protected loading: boolean = true;

  destroy$ = new Subject();

  constructor(adminService: AdminService, modalService: NgbModal) {
    super(adminService, modalService);
    this.filter = new ModuleFilter();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  retrieveItems(): void {
    this.retrieveModules();
  }

  retrieveModules(): void {

    this.loading = true;

    const req: RequestModule = {
      licenseId: this.licenseId
      , active: this.active
      , hasApi: this.hasApi
      , includeHost: this.includeHost
    };

    this.adminService.getModules$(req)
      .pipe(takeUntil(this.destroy$)
        , tap(x => { this.loading = false; }))
      .subscribe(
        resp => {
          this.items = resp.data!;
          this.filteredItems = this.items;
          this.loadItems();
        }
      );

  }

  refreshItems(): void {
    this.retrieveModules();
  }

  saveItem(item: Module, isNew: boolean): void {

    this.adminService.saveModule(item, isNew)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }

  public addHandler({ sender }: any) {

    var module: Module = {
      id: uuidv4(),
      name: "New Module",
      description: "",
      hasApi: false,
      apiUrl: "",
      apiKey: "",
      sortOrder: 999,
      isActive: false,
      applicationId: ""
    };

    const size = 'lg';
    const options = {
      title: "Add Module", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false, saveText: 'Add'
    };

    this.showEditorModal(size, options, ModulesEditorComponent, new ModuleForm(module), true);
  }

  public editHandler({ sender, rowIndex, dataItem }: any) {
    const size = 'lg';
    const options = {
      title: "Edit Module", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };

    this.showEditorModal(size, options, ModulesEditorComponent, new ModuleForm(dataItem), false);
  }

  public removeHandler({ dataItem }: any): void {
    this.adminService.removeModule(dataItem)
      .subscribe(
        _response => {
          // Only close row on success, otherwise flag the error          
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }

}
